import { RouteRecordRaw } from 'vue-router';
import { IRouteConfigAuthMeta } from '@/shared';

const auth: IRouteConfigAuthMeta = {
  required: true,
};

export default [
  {
    path: '/support',
    name: 'SupportIndex',
    component: () => import('@/views/support/Index.vue'),
    meta: {
      auth,
      title: 'Support',
      icon: 'hands-helping',
      active: false,
    },
  },
] as RouteRecordRaw[];
